"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Controller__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_feeRecipient",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        name: "FactoryAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        name: "FactoryRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_module",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "_feeType",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_feePercentage",
                type: "uint256",
            },
        ],
        name: "FeeEdited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newFeeRecipient",
                type: "address",
            },
        ],
        name: "FeeRecipientChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "ModuleAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "ModuleRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_resource",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        name: "ResourceAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_resource",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        name: "ResourceRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        name: "SetAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "SetRemoved",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        name: "addFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_feeType",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_newFeePercentage",
                type: "uint256",
            },
        ],
        name: "addFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "addModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_resource",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        name: "addResource",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "addSet",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_feeType",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_newFeePercentage",
                type: "uint256",
            },
        ],
        name: "editFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newFeeRecipient",
                type: "address",
            },
        ],
        name: "editFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "factories",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeRecipient",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "fees",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getFactories",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_moduleAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_feeType",
                type: "uint256",
            },
        ],
        name: "getModuleFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getModules",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getResources",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_factories",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_modules",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_resources",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_resourceIds",
                type: "uint256[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isFactory",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isModule",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isResource",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isSet",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_contractAddress",
                type: "address",
            },
        ],
        name: "isSystemContract",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "modules",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
        ],
        name: "removeFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "removeModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        name: "removeResource",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "removeSet",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "resourceId",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "resources",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "sets",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var Controller__factory = /** @class */ (function (_super) {
    __extends(Controller__factory, _super);
    function Controller__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Controller__factory.prototype.deploy = function (_feeRecipient, overrides) {
        return _super.prototype.deploy.call(this, _feeRecipient, overrides || {});
    };
    Controller__factory.prototype.getDeployTransaction = function (_feeRecipient, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _feeRecipient, overrides || {});
    };
    Controller__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Controller__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Controller__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    Controller__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    Controller__factory.bytecode = _bytecode;
    Controller__factory.abi = _abi;
    return Controller__factory;
}(ethers_1.ContractFactory));
exports.Controller__factory = Controller__factory;
//# sourceMappingURL=Controller__factory.js.map